import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../../app/hooks";
import { useLazyGetCrystalsQuery } from "../../../crystals/api/crystalApi";
import { useLazyGetFusesQuery } from "../../../fuses/fusesApi";
import {
  useLazyGetStudenGemQuery
} from "../../../gem/api/gemApi";
import { useLazyGetAllXpQuery } from "../../../xp/api/xpApi";
import StudentDetailsGamePresentation from "../../presantation/studentdeatilsgamepresentation/StudentDetailsGamePresentation";
import { accountSelected } from "../../slice/studentSlice";
import { Student, StudentProjectReport } from "../../types/types";
type StudentDetailsGameContainerPros = {
  student: Student;
  projectReport: StudentProjectReport;
  xpDescriptoin: string | null;
  xpAmount: number | null;
  gemAmount: number | null;

  onXpDescripton: (e: React.ChangeEvent<HTMLInputElement>) => void
  onXpAmount: (e: React.ChangeEvent<HTMLInputElement>) => void
  onGemAmount: (e: React.ChangeEvent<HTMLInputElement>) => void
  onOpenAward: () => void
  onCloseAward: () => void
  openAward: boolean
  onAddAward: () => void
}
const StudentDetailsGameContainer: React.FC<
StudentDetailsGameContainerPros
> = ({
  student,
  projectReport,
  gemAmount,
  onAddAward,
  onCloseAward,
  onGemAmount,
  onOpenAward,
  onXpAmount,
  onXpDescripton,
  openAward,
  xpAmount,
  xpDescriptoin
}) => {
  const [xpPanel, setXpPanel] = useState<boolean>(false);
  const account = useAppSelector(accountSelected);
  // const project = useAppSelector(selectedProject);
  const [getAllXp] = useLazyGetAllXpQuery();
  const [
    getAllGem,
    { isSuccess: gemSuccess },
  ] = useLazyGetStudenGemQuery();

  const [
    getAllFuses,
    
  ] = useLazyGetFusesQuery();

  const [
    getCrystal,
  ] = useLazyGetCrystalsQuery();

  // const {
  //   data: getAllGem,
  //   isLoading: gemLoading,
  //   isError: gemError,
  //   isSuccess: gemSuccess,
  // } = useGetStudenGemQuery({
  //   projectId: project?._id as string,
  // });

  const [xpNumber, setXpNumber] = useState<number>(0)
  const [gemNumber, setGemNumber] = useState<number>(0)
  const [fusesNumber, setFusesNumber] = useState<number>(0)
  const [crystalNumber, setCrystalNumber] = useState<number>(0)

  useEffect(() => {
    (async () => {
      if (student) {
        try {
          const xpResult = await getAllXp({
            currentSystem: JSON.stringify(account),
            studentId: String(student._id)
          }).unwrap()

          const gemReult = await getAllGem({
            projectId: account?.project as string,
            student: student._id as string
          }).unwrap()

          const fusesResult = await getAllFuses({
            currentSystem: JSON.stringify(account),
            student: student._id as string
          }).unwrap()

          const crystalResult = await getCrystal({
            currentSystem: JSON.stringify(account),
            student: student._id as string
          }).unwrap()

          setXpNumber(xpResult);
          setGemNumber(gemReult.entities[gemReult!.ids![0]]?.gem!);
          setFusesNumber(Number(fusesResult.entities["undefined"]!));
          setCrystalNumber(Number(crystalResult.entities["undefined"]!));
        } catch (error) {
          console.error(error)
        }
      }
    })()
  }, [account, student])

  const onOpenXpPanel = () => {
    setXpPanel(true)
  }

  const onCloseXpPanel = () => {
    setXpPanel(false)
  }
  return (
    <>
      {gemSuccess && (
        <StudentDetailsGamePresentation
          xpPanel={xpPanel}
          onOpenXpPanel={onOpenXpPanel}
          onCloseXpPanel={onCloseXpPanel}
          student={student}
          account={account!}
          projectReport={projectReport}
          gemAmount={gemAmount}
          onAddAward={onAddAward}
          onGemAmount={onGemAmount}
          onXpAmount={onXpAmount}
          onXpDescripton={onXpDescripton}
          xpAmount={xpAmount}
          xpDescriptoin={xpDescriptoin}
          openAward={openAward}
          onCloseAward={onCloseAward}
          onOpenAward={onOpenAward}
          xpPerProject={xpNumber}
          gemNumber={gemNumber}
          fusesNumber={fusesNumber}
          crystalNumber={crystalNumber}
        />
      )}
    </>
  )
}

export default StudentDetailsGameContainer
